export default __webpack_public_path__ + "static/media/cement.317505f0.svg";